import { apiService } from "./base-api-service";
import { endPoints, getDocOperationServiceEndPoint } from "./api-constants";
import { getAuthHeader, readCookie } from "../utils/helpers";

class DocOperationAPI {
  DocOperationAPI(url) {
    return getDocOperationServiceEndPoint(url);
  }

  docOperationPost(data) {
    const endpoint = this.DocOperationAPI(`${endPoints.docOperationService.DOC_OPERATION}`);
    return apiService.post(endpoint, data, getAuthHeader());
  }
}

export default new DocOperationAPI();
